import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Controls the resubscribe nudge footer banner variants for unsubscribed users.
 * Shows a banner to help unsubscribed users easily resubscribe to marketing emails.
 */
export const FE_RESUBSCRIBE_NUDGE_FOOTER_BANNER_250905 = experiment({
  name: "FE_RESUBSCRIBE_NUDGE_FOOTER_BANNER_250905",
  identifier: "RetailerToken",
  client: ["RETAILER"],
  notifyAfter: "2025-12-31",
  defaultValue: false,
  productArea: "RETAILER_MARKETING",
});

